export enum ContractStatusEnum {
  CANCELED = 12,
  ACTIVE = 11,
}
